import { Box, Text, Button, Heading } from "@chakra-ui/react";
import React from "react";
import { BsGithub } from "react-icons/bs";
import { BiLinkExternal } from "react-icons/bi";
import "./Projects.css";
import { projectdata } from "../../Utils/projectData";
import Carousel from "../../Components/Carousel/Carousel";

export default function Projects() {
  

  return (
    <Box
      id="projects"
      classNames="projects section"
      w="full"
      bg="#040724"
      color="#ffffff"
      textAlign="center"
    >
      <Heading
        fontSize={["2xl", "4xl", "7xl", "4xl", "4xl"]}
        fontWeight="400"
        color={"#00b9e8"}
        mt={["90px", "40px", "", "4px", ""]}
      >
        <Text ml={["", "", "10px"]} color={"#00b9e8"}>
          PROJECTS
        </Text>
      </Heading>
      <Box display="grid" gap="50px" gridTemplateColumns="repeat(1, 1fr)">
      {projectdata &&
            projectdata.map((project) => {
            return (
              <Box
                className="projectouter project-card"
                h={"auto"}
                w={["85%", "85%", "85%", "85%", "85%"]}
                m={"auto"}
                mt={["40px", "40px", "40px", "", ""]}
              >
                <Box
                  display={["inline", "inline", "inline", "inline","flex"]}
                  justifyContent="space-between"
                >
                <Carousel data={project.img} />
                  {/* <Image
                    className="Img"
                    w={["99%", "99%", "60%", "60%", "60%"]}
                    m="auto"
                    src={project.img}
                    alt="project-thumbnail"
                  /> */}

                  <Box w={["100%", "97%", "97%", "39%", "39%"]} m="auto">
                    <Text
                      // color={"orange"}
                      color={"#00b9e8"}
                      fontSize={["2xl", "3xl", "4xl"]}
                      className="project-title"

                    >
                      {project.name}
                    </Text>
                    <Text fontSize={["xl", "2xl", "3xl"]} color={"#00b9e8"}>
                      ( {project.type} )
                    </Text>
                    <Text
                      w={["100%", "90%", "100%"]}
                      m="auto"
                      fontSize={["xs", "lg", "md"]}
                      class="project-description"
                      color={"orange"}
                      textAlign={"justify"}
                      // justifyContent={"justify-content"}
                    >
                      {project.desc}
                    </Text>
                    <Text
                      w="85%"
                      m="auto"
                      fontSize={["sm", "lg", "md"]}
                      fontWeight="bold"
                      color={"orange"}
                      class="project-tech-stack"
                    >
                      Techstacks :-{project.techstack}
                    </Text>
                    <Box
                      display="flex"
                      w={["100%", "80%", "100%"]}
                      m="auto"
                      justifyContent="space-around"
                    >
                      <Button
                        className="project-deployed-link"
                        as="a"
                        target="_blank"
                        href={project.livelink}
                        _hover={{ bg: "orange", color: "blue" }}
                        mt="10px"
                        p={["5px 5px", "10px 10px", "10px 10px"]}
                        fontSize={["md", "lg", "lg"]}
                        bg="#040724"
                        border="2px solid orange"
                        color="orange"
                        variant="solid"
                        leftIcon={<BiLinkExternal />}
                      >
                        Live
                      </Button>
                      <Button
                        className="project-github-link"
                        as="a"
                        target="_blank"
                        href={project.gitlink}
                        _hover={{ bg: "orange", color: "blue" }}
                        mt="10px"
                        p={["5px 5px", "10px 10px", "10px 10px"]}
                        fontSize={["md", "lg", "lg"]}
                        bg="#040724"
                        border="2px solid orange"
                        color="orange"
                        variant="solid"
                        leftIcon={<BsGithub />}
                      >
                        Github
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Box>
            );
          })}
      </Box>
    </Box>
    // </Box>
  );
}
